"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OVERVIEW = void 0;
var OVERVIEW = {
  TEXT__CUSTOMER_NAME: 'newCreditNoteOverview-span-customerName',
  TEXT__NON_STOCK_CREDIT: 'newCreditNoteOverview-span-nonStockCredit',
  BUTTON__EDIT_CUSTOMER: 'newCreditNoteOverview-button-editCustomer',
  TEXT__PRODUCTS_HEADER: 'newCreditNoteOverview-span-selectedProducts',
  TEXT__PRODUCT_NAME: 'newCreditNoteOverview-span-productName',
  TEXT__PRODUCT_CATEGORY: 'newCreditNoteOverview-span-productCategory',
  TEXT__PRODUCT_SKU: 'newCreditNoteOverview-span-productSKU',
  TEXT__PRODUCT_QUANTITY: 'newCreditNoteOverview-span-productQuantity',
  TEXT__PRODUCT_PRICE: 'newCreditNoteOverview-span-productPrice',
  BUTTON__TOGGLE_LIST: 'newCreditNoteOverview-button-toggleProductsList',
  BUTTON__EDIT_PRODUCTS: 'newCreditNoteOverview-button-editProducts',
  LABEL__RETURN_TO_INVENTORY: 'newCreditNoteOverview-label-returnToInventory',
  BUTTON__WAREHOUSE: 'newCreditNoteOverview-button-warehouse',
  TEXTAREA__NOTE: 'newCreditNoteOverview-textarea-note',
  TEXT__TOTAL_AMOUNT: 'newCreditNoteOverview-span-total',
  TEXT__TOTAL_TOOLTIP: 'newCreditNoteOverview-span-totalTooltip'
};
exports.OVERVIEW = OVERVIEW;